import * as React from "react";
import TinTucService from "../../services/tinTuc";
import { TinTucNew, TinTuc } from "../../models";


export interface Props {
  tinTucUrl: string;
  id: string;
}

export interface State {
  tinTuc: TinTuc;
}

export default class ModalTinTuyenSinh extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      tinTuc: null
    };
  }

  componentDidMount() {
    TinTucService.getTinTucDetail(this.props.tinTucUrl).then(tinTuc => {
      this.setState({ tinTuc: tinTuc.tinTuc });
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        id={this.props.id}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <button
          type="button"
          className="close closemodal"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="modal-dialog modal-lg" role="document">
          {!this.state.tinTuc ? (
            <div className="modal-content">
              
              Không có tin
            </div>
          ) : (
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{this.state.tinTuc.tieuDe}</h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className="modal-body"
                  dangerouslySetInnerHTML={{ __html: this.state.tinTuc.noiDung }}
                />
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                </button>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}
